import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { HeroColumns } from './s'
import ModuleTitle from 'components/module-title'
import { Plain } from 'components/button'
import ExportUsers from 'pages/people/hero/export-users'
import Modal from 'modals/dialog'
import CalculationInfo from 'pages/insights/modals/calculation-info'

const InsightsHero = ({ corporation = false, showUnitPermissionDisclaimer, salt }) => {
    const [showingInformation, setShowingInformation] = useState(false)

    return (
        <HeroColumns>
            <div>
                <ModuleTitle which="insights" />
                <Plain
                    className="constructive"
                    onClick={() => setShowingInformation(true)}>
                    <FormattedMessage
                        id="insights_action_show_info"
                        defaultMessage="What are the numbers based on?" />
                </Plain>
                <Modal
                    show={!!showingInformation}
                    dismiss={() => setShowingInformation(false)}
                    className="scrollable">
                    <CalculationInfo showUnitPermissionDisclaimer={showUnitPermissionDisclaimer} />
                </Modal>
            </div>
            {!corporation && <ExportUsers salt={salt} />}
        </HeroColumns>
    )
}

export default InsightsHero